window.root_element = if navigator.userAgent.toLowerCase().indexOf('firefox') != -1 then $('html') else $('body');

window.limit_mobile = 800

window.htmltorgb = (hex)->
  hex = hex.replace(/^\s*#|\s*$/g, '')
  if hex.length == 3
    hex = hex.replace(/(.)/g, '$1$1')
  r = parseInt(hex.substr(0, 2), 16)
  g = parseInt(hex.substr(2, 2), 16)
  b = parseInt(hex.substr(4, 2), 16)
  return [r,g,b]

TAScrollTo = (element, to, duration)->
  if $('html').hasClass('msie') and element == root_element
    TASetRootScrollTop(to)
  else
    current_top = if $('html').hasClass('msie') then element.scrollTop else element.scrollTop()
    difference = to - current_top
    perTick = difference / duration * 2
    if duration > 0
      setTimeout ->
        element.scrollTop(element.scrollTop() + perTick)
        TAScrollTo(element, to, duration - 2)
      , 10

TASetRootScrollTop = (val)->
  if $('html').hasClass('msie')
    el = (document.documentElement || document.body)
    el.scrollTop = val
  else
    root_element.scrollTop(val)

TASetMobileClasses = ->
  w_window = $(window).width()
  if w_window <= limit_mobile
    $('.menu').addClass('mobile')
  else
    $('.menu').removeClass('mobile')
    $('#menu-wrapper > div').perfectScrollbar('destroy')

TASetMinHeightWrapper = ->
  h_window = $(window).height()
  wrapper = $('#wrapper')
  wrapper.css('minHeight', h_window - wrapper.offset().top)

TAStickyFooter = ->
  footer = $('#footer')
  wrapper = $('#wrapper')
  fh = footer.outerHeight()
  if (Math.round(footer.offset().top) + fh) <= $(window).height()
    wrapper.css('paddingBottom', fh)
    footer.addClass('sticky-footer')
  else
    wrapper.css('paddingBottom', '')
    footer.removeClass('sticky-footer')

TACarouselMenu = ->
  if $('#header .menu').width() > $('#menu-wrapper').outerWidth() and $(window).width() > window.limit_mobile
    $('#menu-wrapper').addClass('with-carousel')
  else
    $('#menu-wrapper').removeClass('with-carousel')

TAChangeNumSlideItemCarousel = (num, parent)->
  parent.find('.slide-win-prev').attr('data-target', '-='+num)
  parent.find('.slide-win-prev').data('target', '-='+num)
  parent.find('.slide-win-next').attr('data-target', '+='+num)
  parent.find('.slide-win-next').data('target', '+='+num)

TAFixCarousels = ->
  w_window = $(window).width()
  if $('#matches, #games').length > 0
    $('#matches, #games').each ->
      refreshJcarousel = false
      num = 5
      content_carousel = if $(@).attr('id') == 'matches' then $('#matches .matches-wrapper') else $('#games .games-wrapper')
      wrap_carousel = content_carousel.parent()
      if w_window <= 990 && w_window > 808
        num = 4
      else if w_window <= 808 && w_window > 626
        num = 3
      else if w_window <= 626 && w_window > 444
        num = 2
      else if w_window <= 444
        num = 1
      if wrap_carousel.find('.slide-win-prev').data('target') != "-="+num
        TAChangeNumSlideItemCarousel(num, wrap_carousel)
        refreshJcarousel = true
      if refreshJcarousel
        content_carousel.jcarousel("reload", content_carousel.data())
        _prev = wrap_carousel.find('.slide-win-prev')
        _next = wrap_carousel.find('.slide-win-next')
        _prev.jcarouselControl("reload", _prev.data())
        _next.jcarouselControl("reload", _next.data())

  if $('body.home #events-bar').length > 0
    refreshJcarousel = false
    num = 4
    content_carousel = $('body.home #events-bar .events-wrapper')
    wrap_carousel = content_carousel.parent()
    if w_window <= 990 && w_window > 761
      num = 3
    else if w_window <= 761 && w_window > 535
      num = 2
    else if w_window <= 535
      num = 1
    if wrap_carousel.find('.slide-win-prev').data('target') != "-="+num
      TAChangeNumSlideItemCarousel(num, wrap_carousel)
      refreshJcarousel = true
    if refreshJcarousel
      _prev = wrap_carousel.find('.slide-win-prev')
      _next = wrap_carousel.find('.slide-win-next')
      _prev.jcarouselControl("reload", _prev.data())
      _next.jcarouselControl("reload", _next.data())

  if $('#carousel-other-items').length > 0
    coi = $('#carousel-other-items')
    if w_window > 990
      $('#carousel-other-items .item-wrapper').css('width', '')
    else if (w_window < 990 and w_window > 720) or w_window < 616 # 1 solo item
      $('#carousel-other-items .item-wrapper').css('width', coi.width())
    else if w_window <= 720 and w_window >= 616 # 2 item
      $('#carousel-other-items .item-wrapper').css('width', coi.width()/2)
    coi.find('ul').css('width', $('#carousel-other-items .item-wrapper').first().outerWidth() * $('#carousel-other-items .item-wrapper').length)
    coi.jcarousel('reload')

TAResizeAndCenterImages = ->
  w_window = $(window).width()
  arr = ['#location-home .content-maps img', '#shop-home .box-img img', '#articles-home .box-img img', '#event-home .box-img img', '#notices-home .box-img img', '#last-photo-home img', '#last-video-home img', '.content-list-img img', '.shop-page .box-img img', '#carousel-other-items .box-img img', '.archive-page .article .box-img img', '#carousel-events-all .box-img img', '.team-page-template .media-box img', '#related-posts img']
  $.each arr, (idx,el)->
    $(el).removeAttr('style')
    $(el).attr('data-rac', 'true')
  data_resize_and_center()
  # data_center_image()

TAShowRanking = ->
  $('#content-rank-home').children().hide()
  $('#content-rank-home').find('.rank-team.ps-container').each ->
    $(@).perfectScrollbar('destroy')
    $(@).removeClass('ps-container')
  showRank = $('#team-rank').val()
  $(showRank).show()
  $(showRank).find('.rank-team').perfectScrollbar()
  _href = $(showRank).find('a').attr('href')
  $('#rankings-home .bottom a').attr('href', _href)

TACenterHeaderMobile = ->
  if $('#header .header-img').length > 0
    w_window = $(window).width()
    _img = $('#header .header-img img')
    if w_window <= 800
      _img.removeAttr('style')
      _img.attr('data-rac', 'true')
      data_resize_and_center()
    else
      _img.removeAttr('style')
      _img.removeAttr('data-rac')

window.TACallbackClickDirection = ->
  TAScrollTo(root_element, 0, 100)

# Visualizzazione blocco successivo
TAShowNextBoxAlbums = (box)->
  if $.browser.msie && parseInt($.browser.version, 10) == 7 then $("#box"+box+"-albums").show() else $("#box"+box+"-albums").slideToggle("slow")
  $("#more-albums").addClass("disabled") if $("#box"+(box+1)+"-albums").length == 0

# Visualizzazione blocco successivo
TAShowNextBoxMedias = (box)->
  if $.browser.msie && parseInt($.browser.version, 10) == 7 then $("#box"+box+"-medias").show() else $("#box"+box+"-medias").slideToggle("slow")
  $("#more-medias").addClass("disabled") if $("#box"+(box+1)+"-medias").length == 0

# Callback dopo click su carousel video
window.TASetCurrentMedia = (link)->
  link.parents('#carousel-related-media').find('.current').removeClass('current')
  link.addClass('current')

TATopElementOnMobile = ->
  w_window = $(window).width()
  el = $('.top-on-mobile:not(.placeholder)')
  if el.length > 0
    if w_window <= 720
      el2 = $('.top-on-mobile.placeholder')
      if el2.length == 0
        el2 = el.clone()
        el2.addClass('placeholder')
        el2.css('marginBottom', 10)
        console.log "Aggiungo l'elemento sopra"
        el2.insertBefore('.content-page')
      el.addClass('hidden')
    else if el.length > 0
      el.removeClass('hidden')
      $('.top-on-mobile.placeholder').remove()

$ ->
  window.root_element = if navigator.userAgent.toLowerCase().indexOf('firefox') != -1 then $('html') else $('body')
  mobileClass = "no-mobile"
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
    mobileClass = "mobile"
    if /Android|android/.test(navigator.userAgent)
      mobileClass += " android";
    else if /iPad/.test(navigator.userAgent)
      mobileClass += " ipad"
  $('html').addClass(mobileClass)

  window.windowWidth = $(window).width()

  if window.windowWidth <= limit_mobile
    $('#header .menu').css 'visibility', 'visible'

  TATopElementOnMobile()

  # Caricamento Header
  if typeof wp != "undefined" and wp.customize
    wp.customize "header", (value)->
      value.bind (newval)->
        if newval==""
          $("#header .header-img").hide()
          $("#header .header-text").removeClass('hidden')
        else
          $("#header .header-img img").attr('src', newval)
          $("#header .header-text").addClass('hidden')
          $("#header .header-img").show()

  # Aggiungo una classe per dire che c'è la barra in alto
  if $('#TActb').length > 0
    $('html').addClass('with-TActb')

  TASetMinHeightWrapper()
  TAStickyFooter()
  TASetMobileClasses()
  TACenterHeaderMobile()

  # Carousel menu
  $('#menu-wrapper .arrow').on 'click', (event)->
    event.preventDefault()
    arrow = $(@)
    unless arrow.hasClass('disabled')
      prev_arrow = $('#menu-wrapper .arrow.prev')
      next_arrow = $('#menu-wrapper .arrow.next')
      menu = $('#header .menu')
      wrapper = $('#menu-wrapper')
      current_step = if menu.data('step')? then parseInt(menu.data('step'), 10) else 0
      step = wrapper.width()
      currentLeft = parseInt(menu.css('left'), 10)
      if arrow.hasClass('prev')
        current_step -= 1
        _left = currentLeft + step
        _left = 0 if _left > 0
        next_arrow.removeClass('disabled')
        prev_arrow.addClass('disabled') if _left == 0
      else
        current_step += 1
        max_left = (menu.width() - wrapper.width()) * -1
        _left = currentLeft - step
        _left = max_left if _left < max_left
        prev_arrow.removeClass('disabled')
        next_arrow.addClass('disabled') if _left == max_left
      menu.css 'left', _left
      menu.data 'step', current_step

  # Menu responsive
  $('#menu-mobile').on 'click', (event)->
    event.preventDefault()
    menu = $('#menu-wrapper')
    content_menu = menu.find('> div')
    if menu.hasClass('open')
      menu.removeClass('open')
      menu.css('maxHeight', '')
      content_menu.css('maxHeight', '')
      content_menu.perfectScrollbar('destroy')
      menu.find('ul.children').removeClass('open')
    else
      menu.addClass('open')
      _max_height = $(window).height() - menu.offset().top
      menu.css('maxHeight', _max_height)
      content_menu.css('maxHeight', _max_height)
      content_menu.perfectScrollbar()

  $('#menu-wrapper ul .page_item a').on 'click', (event)->
    page_item = $(@).parents('.page_item').first()
    if $('#menu-mobile').is(':visible') and page_item.children('ul.children').length > 0
      unless page_item.children('ul.children').hasClass('open')
        event.preventDefault()
        $('#menu-wrapper ul.children').removeClass('open')
        $('#menu-wrapper a.active').removeClass('active')
        page_item.children('ul.children').addClass('open')
        page_item.children('a').addClass('active')
        if page_item.parents('.page_item').length > 0
          page_item.parents('.page_item').children('a').addClass('active')
        page_item.parent('ul.children').addClass('open') if page_item.parent('ul.children').length > 0
      else
        if page_item.attr('href') == '#'
          page_item.children('ul.children').removeClass('open')
        else if event.offsetX > 170 # Se si clicca sulla freccia faccio chiudere il menu
          event.preventDefault()
          page_item.children('ul.children').removeClass('open')
          page_item.children('a').removeClass('active')
      page_item.parents('#menu-wrapper').find('> div').perfectScrollbar('update')
  # Fine menu responsive

  # Carousel con i data
  $('[data-jcarousel]').each ->
    el = $(@)
    el.jcarousel el.data()
    start_el = $("#"+el.attr('id')+"-start")
    if(start_el.length > 0 && typeof start_el.data('start') != 'undefined')
      _start = start_el.data('start')
      _reverse = if start_el.data().reverse? then true else false
      el.jcarousel 'scroll', _start
      if start_el.data('scroll')
        n_scroll = start_el.data('scroll')
        limit_inactive_next = el.find(el.data().items).length - n_scroll - 1
        if limit_inactive_next <= _start
          if _reverse
            el.parent().find('.slide-win-prev').addClass('inactive')
          else
            el.parent().find('.slide-win-next').addClass('inactive')
        else if _start == 0
          if _reverse
            el.parent().find('.slide-win-next').addClass('inactive')
          else
            el.parent().find('.slide-win-prev').addClass('inactive')

  $('[data-jcarousel-control]').each ->
    el = $(@)
    el.jcarouselControl el.data()
    el.on "jcarouselcontrol:inactive", ->
      $(@).addClass('inactive')
    el.on "jcarouselcontrol:active", ->
      $(@).removeClass('inactive')
  # Fine carousel con i data

  # Click sul link Condividi degli articoli in homepage
  $('#articles-home .article, .archive-page .article').on 'click', (event)->
    target = $(event.target)
    if target.hasClass('link-share') or target.parents('.link-share').length > 0
      event.preventDefault()
      box_article = target.parents('.article')
      content_box_articles = box_article.parent()
      box_share = box_article.next()
      if box_share.is(':visible')
        box_share.hide()
      else
        content_box_articles.find('.box-share').hide()
        content_box_articles.find('.new-share-box').hide()
        bottom_article = box_article.find('.bottom-article')
        _top = bottom_article.position().top - 50
        box_share.css('top', _top)
        box_share.show()
        inizializeZclip() if box_share.find('.clipboard').length == 0

  # Cambio classifica in homepage
  $('#team-rank').on 'change', ->
    TAShowRanking()

  # Perfect scrollbar sulle classifiche in homepage
  if $('#content-rank-home').length > 0
    $('#content-rank-home').children().first().find('.rank-team').perfectScrollbar()

  # Scroll alle indicazione stradali quando si cercano
  $("#start_route").on 'calcRoute', ->
    setTimeout ->
      TAScrollTo(root_element, $('#box-route-info').offset().top, 100)
    , 1000

  # Prevent click su sponsor senza link
  $('.sponsor-template-page .sponsor-category .sponsor .content-img a[href="#"]').on 'click', (event)->
    event.preventDefault()

  # Perfect scrollbar su post per data e categorie
  if $('#sidebar-date').length > 0
    $('#sidebar-date .content > div').perfectScrollbar()

  if $('#sidebar-category').length > 0
    $('#sidebar-category .content > div').perfectScrollbar()

  # Visualizzazione di altri album
  numberBoxAlbum = 2
  $("#more-albums").on "click", (event)->
    event.preventDefault()
    TAShowNextBoxAlbums(numberBoxAlbum)
    numberBoxAlbum++

  # Visualizzazione di altri media
  numberBoxMedia = 2
  $("#more-medias").on "click", (event)->
    event.preventDefault()
    TAShowNextBoxMedias(numberBoxAlbum)
    numberBoxMedia++

  # Click sul link Condividi su foto singola
  $('#info-media-single .link-share').on 'click', (event)->
    event.preventDefault()
    link = $(@)
    box_share = link.next()
    box_share = box_share.children() if box_share.hasClass('content-box-share')
    if box_share.is(':visible')
      box_share.hide()
    else
      _top = link.position().top - (box_share.outerHeight() + 6)
      box_share.css('top', _top)
      box_share.show()
      inizializeZclip() if box_share.find('.clipboard').length == 0

  # Toggle ricerca avanzata media
  $('#advanced-search span').on 'click', (event)->
    event.preventDefault()
    box = $(@).parents('#search-media')
    if box.hasClass('small')
      box.removeClass('small')
    else
      box.addClass('small')

  # Gestione commenti
  $(".wrap-comments-content textarea").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $(".wrap-comments-content textarea").on "focus", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $('#add-comment-link').on 'click', (event)->
    event.preventDefault()
    $('textarea#comment').focus() unless $('.wrap-comments-content').hasClass('open')

  $("#show-comments").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    textareaComment = $(".wrap-comments-content textarea")
    showComments = $(@)
    next = showComments.attr('data-opposite-text')
    actual = showComments.html()
    titleBtn = showComments.attr("title")
    if actual != titleBtn
      wrapComments.addClass('open')
    else
      wrapComments.removeClass('open')
      if textareaComment.val() == ""
        textareaComment.val textareaComment.attr('data-default')
    showComments.attr 'data-opposite-text', actual
    showComments.html next
  # Fine gestione commenti

  if $('#related-posts').length > 0 and $('#related-posts a').length > 3
    $('#related-posts .content').perfectScrollbar()

  TAFixCarousels()

  $('#privacy-policy h3').addClass('title-bar-darken')
  $('#privacy-policy h3').html "<span class=\"text\">#{$('#privacy-policy h3').text()}</span>"

  # Rimuovo i <p> vuoti nel testo
  $('.single-page .content-page .content .text p, .standard-page .content-page .content .text p').each ->
    $(@).remove() if $(@).text().trim() == ''

  $('body.page-template-page-template-custom.with-blocks #content p').each ->
    $(@).remove() if $(@).text().trim() == ''

$(window).on 'load', ->
  # Aspetto il caricamento della pagina per far vedere il menu così evito l'effetto di spostamento
  TACarouselMenu()
  $('#header .menu').css 'visibility', 'visible'
  # Aggiungo una classe per dire che c'è la barra in alto
  if $('#TActb').length > 0
    $('html').addClass('with-TActb')
  # Verifico lo TAStickyFooter
  TAStickyFooter()

$(window).on 'resize', ->
  w_window = $(window).width()

  if w_window != window.windowWidth # Verifico che si stia veramente ridimensionando la finestra
    window.windowWidth = $(window).width()

    TACarouselMenu()
    TASetMinHeightWrapper()
    TAStickyFooter()
    TASetMobileClasses()
    TAFixCarousels()
    TAResizeAndCenterImages()
    TACenterHeaderMobile()
    TATopElementOnMobile()

    # Fix left carousel menu
    if $('#menu-wrapper').hasClass('with-carousel')
      menu = $('#header .menu')
      current_step = if menu.data('step')? then parseInt(menu.data('step'), 10) else 0
      if current_step > 0
        wrapper = $('#menu-wrapper')
        step = wrapper.width()
        max_left = (menu.width() - wrapper.width()) * -1
        _left = (step * current_step) * -1
        _left = max_left if _left < max_left
        _left = 0 if _left > 0
        menu.css 'left', _left

    # Chiudo il menu
    if(w_window <= limit_mobile && $('#menu-wrapper').is(':visible'))
      $('#menu-wrapper').removeClass('open')
      $('#menu-wrapper ul.children').removeClass('open')

    # Chiudo i box di condivisione degli articoli in home
    if $('#articles-home .box-share:visible').length > 0
      $('#articles-home .box-share:visible').hide()

    if $('#articles-home .new-share-box:visible').length > 0
      $('#articles-home .new-share-box:visible').hide()

    # Fix posizionamento dialog
    if $('.ui-dialog').is(':visible') and w_window > 320
      if w_window > 620
        _left = parseInt(((w_window - $('.ui-dialog').width()) / 2), 10)
        $('.ui-dialog').css
          left: _left
          right: ''
          width: '100%'
      else
        $('.ui-dialog').css
          left: 10
          right: 10
          width: 'auto'
      $('.ui-dialog .ui-dialog-content').dialog 'option', 'position',
        my: "top"
        at: "top"
        of: window
        offset: "0 30"

    # Nascondo il box dello share per la foto singola
    $('#info-media-single .box-share').hide() if $('#info-media-single .box-share').is(':visible')
    $('#info-media-single .new-share-box').hide() if $('#info-media-single .new-share-box').is(':visible')

$(document).on 'click', (event)->
  w_window = $(window).width()
  target = event.target
  # Chiudo il menu
  if w_window <= limit_mobile && $('#menu-wrapper').hasClass('open') && $(target).parents('#menu-wrapper').length == 0 && $(target).attr('id') != 'menu-wrapper' && $(target).attr('id') != 'menu-mobile'
    $('#menu-wrapper').removeClass('open')
    $('#menu-wrapper ul.children').removeClass('open')
    $('#menu-wrapper a.active').removeClass('active')
  # Chiudo i box di condivisione degli articoli in home
  if $('#articles-home .box-share:visible').length > 0 and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.box-share').length == 0 and not $(target).hasClass('box-share')
    $('#articles-home .box-share:visible').hide()
  if $('#articles-home .new-share-box:visible').length > 0 and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.new-share-box').length == 0 and not $(target).hasClass('new-share-box')
    $('#articles-home .new-share-box:visible').hide()
  # Chiudo i box di condivisione degli articoli nella pagina dell'archivio
  if $('.archive-page .box-share:visible').length > 0 and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.box-share').length == 0 and not $(target).hasClass('box-share')
    $('.archive-page .box-share:visible').hide()
  if $('.archive-page .new-share-box:visible').length > 0 and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.new-share-box').length == 0 and not $(target).hasClass('new-share-box')
    $('.archive-page .new-share-box:visible').hide()
  # Chiudo i box di condivisione in foto singola
  if $('#info-media-single .box-share').is(':visible') and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.box-share').length == 0 and not $(target).hasClass('box-share')
    $('#info-media-single .box-share').hide()
  if $('#info-media-single .new-share-box').is(':visible') and not $(target).hasClass('link-share') and $(target).parents('.link-share').length == 0 and $(target).parents('.new-share-box').length == 0 and not $(target).hasClass('new-share-box')
    $('#info-media-single .new-share-box').hide()
